// Planny's public marketing site.
export const Planny_Website_Url = "https://yourplanny.com";
